import { useToast } from '@react/shared/components/Toast';
export function useShare() {
  const { pushSuccess: notifyInfo, pushError: notifyError } = useToast();

  const share = ({
    title,
    text,
    url
  }: {
    title: string;
    text: string;
    url: string;
  }) => {
    if (!('navigator' in window)) {
    }

    if ('share' in navigator) {
      navigator.share({ title, text, url });
      return;
    }

    if ('clipboard' in navigator) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      navigator.clipboard
        .writeText(url)
        .then(() => {
          notifyInfo('Link copied to clipboard');
        })
        .catch(() => {
          notifyError('Failed to copy link');
        });
    }
  };
  return { share };
}
